import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Button } from '@material-ui/core';
import ListDesc from './Descriptive';
import BarChart from './Bar';
import ListSims from './Similars';
import SimpleMap from './Map';
import {Flex, Box} from 'rebass';
import {Redirect} from 'react-router-dom';
import {baseurl} from '../../config';

export default function Search(props) {
  
  const [redirect, setRedirect] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [tempQuery, setTempQuery] = useState("");

  const [data, setData] = useState(["Loading..."]);
  const [dataSpecific, setDataSpecific] = useState({});

  const sendData = async () => {
    try {
      const response = await fetch(baseurl+`/whiskey_scatter`);
      const output = await response.json();
      setData(output.whiskey);
      console.log(output.whiskey);
    } catch (error) {
      console.log(error);
    };
  };

  async function postData(data = {}) {
    // Default options are marked with *
    const response = await fetch(baseurl+`/whiskey_specific`, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'no-referrer', // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    const output = await response.json(); // parses JSON response into native JavaScript objects
    setDataSpecific(output);
    console.log(output)
  }

  if (data.length < 2){
    sendData();
  }

  if (props.query && loaded === false){
    postData({whiskey:props.query});
    setLoaded(true);
  }

  if (redirect === true) {
    return <Redirect to="/Search2" />
  }

  return (
    <div>

    <Flex>
      <Box width={1/4}></Box>
      <Box width={1/2} mt={10} mb={20} justifyContent='center' style={{borderWidth: '1px', borderStyle: 'solid', borderColor: 'black'}}>
        {data.length > 2 && (
          <div>
          <Autocomplete
            onSelect={e => setTempQuery(e.target.value)}
            id="combo-box-demo"
            options={data}
            autoComplete={true}
            autoHighlight={true}
            clearOnEscape={true}
            style={{ width:"100%"}}
            renderInput={params => (
              <TextField {...params} label="SEARCH FOR A WHISKEY" variant="filled" fullWidth />
            )}
          />
          </div>
        )}
      </Box>
      <Box width={1/4}></Box>
    </Flex>

    <Button onClick={e => {props.setQuery(tempQuery); setLoaded(false); setRedirect(true)}} style={{height:"80px", width:"25%", margin:"0px", backgroundColor:'#022140', color:'white', fontFamily:'arial black', fontSize:32, borderWidth: '3px', borderStyle: 'solid', borderColor: 'black', borderRadius: '10px 10px 10px 10px'}}>Search</Button>

    {Object.entries(dataSpecific).length > 1 && (
      
      <div>

      <div>
      <Box sx={{my:'20px', backgroundColor:'#BDBDBD', borderWidth: '3px', borderStyle: 'solid', borderColor: 'black'}}>
          <Flex backgroundColor="#022140">
            <Box  width={1} height={50} pl={5} style={{textAlign:"left", fontFamily:"arial black", color:"white", fontSize: 32}}>
            {dataSpecific.stats[0]}
            </Box>
          </Flex>

          <Flex>
              <Box width={1/2}>
                <Box pl={5} py={2} textAlign="left" fontFamily="arial black" fontSize={24}>{"Type: "+dataSpecific.stats[4]}</Box>
                <Box as='hr' sx={{bg: 'gray', border: 0, height: 1}}/>
                <Box pl={5} py={2} textAlign="left" fontFamily="arial black" fontSize={24}>{"Brand: "+dataSpecific.stats[5]}</Box>
                <Box as='hr' sx={{bg: 'gray', border: 0, height: 1}}/>
                <Box pl={5} py={2} textAlign="left" fontFamily="arial black" fontSize={24}>{"Distillery: "+dataSpecific.stats[6]}</Box>
                <Box as='hr' sx={{bg: 'gray', border: 0, height: 1}}/>
                <Box pl={5} py={2} textAlign="left" fontFamily="arial black" fontSize={24}>{"Owner: "+dataSpecific.stats[7]}</Box>
                <Box as='hr' sx={{bg: 'gray', border: 0, height: 1}}/>
                <Box pl={5} py={2} textAlign="left" fontFamily="arial black" fontSize={24}>{"Number of Reviews: "+dataSpecific.stats[1]}</Box>
                <Box as='hr' sx={{bg: 'gray', border: 0, height: 1}}/>
                <Box pl={5} py={2} textAlign="left" fontFamily="arial black" fontSize={24}>{"Average Rating: "+dataSpecific.stats[2]}</Box>
                <Box as='hr' sx={{bg: 'gray', border: 0, height: 1}}/>
                <Box pl={5} py={2} textAlign="left" fontFamily="arial black" fontSize={24}>{"Standard Deviation: "+dataSpecific.stats[3]}</Box>
                
              </Box>
              <Box width={1/2}>
                <SimpleMap center={{lat: dataSpecific.stats[8], lng: dataSpecific.stats[9]}} zoom={dataSpecific.stats[10]} />
              </Box>
          </Flex>
        </Box>
      </div>

      <div>
        <Box sx={{pb:'15px', my:'20px', backgroundColor:'#BDBDBD', borderWidth: '3px', borderStyle: 'solid', borderColor: 'black'}}>
          <Flex backgroundColor="#022140">
            <Box  width={1} height={50} pl={5} style={{textAlign:"left", fontFamily:"arial black", color:"white", fontSize: 32}}>
              Top Flavors <font size="5">(average occurances)</font>
            </Box>
          </Flex>
          <ListDesc words={dataSpecific.descriptive} />
        </Box>
      </div>
    
      <div>
      <Box sx={{pb:'15px', my:'20px', backgroundColor:'#BDBDBD', borderWidth: '3px', borderStyle: 'solid', borderColor: 'black'}}>
        <Flex backgroundColor="#022140">
            <Box width={1} height={50} pl={5} style={{textAlign:"left", fontFamily:"arial black", color:"white", fontSize: 32}}>
              Profile
            </Box>
        </Flex>
        <Box sx={{m: '20px'}}>
          <BarChart x={dataSpecific.flavors} />
        </Box>
      </Box>
      </div>
    
      <div>
      <Box sx={{pb:'15px', my:'20px', backgroundColor:'#BDBDBD', borderWidth: '3px', borderStyle: 'solid', borderColor: 'black'}}>
        <Flex backgroundColor="#022140">
          <Box  width={1} height={50} pl={5} style={{textAlign:"left", fontFamily:"arial black", color:"white", fontSize: 32}}>
            Similar Whiskeys
          </Box>
        </Flex>
        <ListSims similars={dataSpecific.similars} setRedirect={setRedirect} setQuery={props.setQuery}/>
      </Box>
      </div>

    </div>
    
    )}

    </div>
    
  );
}